import api from '@/services/api';
const ENTITY_ENDPOINT = 'forma';

export class FormaService {
  /**
   * Obtiene todas las formas con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todas las formas con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Obtiene una forma por su ID
   * @param {string|number} id - ID de la forma
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea una nueva forma
   * @param {Object} forma - Datos de la forma a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(forma) {
    return await api.post(`/${ENTITY_ENDPOINT}`, forma);
  }

  /**
   * Actualiza una forma existente
   * @param {string|number} id - ID de la forma
   * @param {Object} forma - Datos de la forma a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, forma) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, forma);
  }

  /**
   * Elimina una forma
   * @param {string|number} id - ID de la forma
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }
}

export default FormaService;
